<template>
  <div v-if="showModal" class="side__modal opened">
    <div class="side__modal__content">
      <div class="modal__top">
        <div class="modal__header">
          <h3 class="modal__title">{{ $lang.app.COST_CALCULATION }}</h3>
          <span class="modal__close" @click="closeModal">
          <svg viewBox="0 0 20 20" width="20" height="20"><use xlink:href="@/assets/v2/img/sprite.svg#modal__close"></use></svg></span>
        </div>
      </div>

      <Form class="modal__footer"
            @submit="submit">

        <div v-for="(payment, index) in form.payments" :key="index"
             class="rounded-lg border border-solid border-gray-200 py-2 px-4 mb-4">
          <SectionResolutionAnswerPaymentForm :payment="payment" :index="index"/>
          <div class="flex justify-end">
            <button @click="deletePayment(index)" type="button" :title="$lang.app.DELETE" class="text-gray-300 ml-2">
              <svg class="fill-current" viewBox="0 0 24 24" width="24" height="24">
                <use xlink:href="@/assets/v2/img/sprite.svg#icon__remove"></use>
              </svg>
            </button>
          </div>
        </div>
        <div class="mb-4">
          <button type="button" class="button button--default button--bordered button--full mb2"
                  @click="addPayment">
            <svg class="fill-current icon" viewBox="0 0 24 24" width="24" height="24">
              <use xlink:href="@/assets/v2/img/sprite.svg#icon__plus"></use>
            </svg>
            {{ $lang.app.ADD }}
          </button>
        </div>

        <div class="between__buttons">
          <button type="button" class="button button__modal__close button--cancel"
                  @click="closeModal">{{ $lang.app.CANCEL }}</button>
          <button type="submit" class="relative button button__modal__close"
                  :disabled="submitting">
            {{ $lang.app.SAVE }}
            <div v-if="submitting" class="loading-blue text-white absolute z-10 w-full rounded-lg h-full top-0 left-0 flex items-center justify-center">
              <div class="block animate-spin">
                <RefreshIcon class="w-6 h-6 mirror-y"/>
              </div>
            </div>
          </button>
        </div>
      </Form>
    </div>
  </div>
</template>
<script>
import {Form} from 'vee-validate'
import SectionResolutionAnswerPaymentForm from "../../../../../components/employee/application/resolution/SectionResolutionAnswerPaymentForm.vue";
import paymentApi from "../../../../../api/employee/payment";

export default {
  components: {
    Form,
    SectionResolutionAnswerPaymentForm,
  },
  data() {
    return {
      showModal: false,

      resolution: null,

      submitting: false,
      form: {
        payments: [],
      },
    };
  },
  methods: {
    openModal() {
      this.showModal = true
      this.$emitter.emit('body-unscrollable')
    },
    closeModal() {
      this.showModal = false
      this.$emitter.emit('body-scrollable')
    },
    addPayment() {
      this.form.payments.push({
        expertPurposeTypeCategory: null,
        expertPurposeType: null,
        value: '',
        unitOfMeasurement: null,
        description: null
      })
    },
    deletePayment(index) {
      this.form.payments.splice(index, 1)
    },
    submit(values, actions) {
      this.submitting = true
      paymentApi
          .addPayments(this.resolution.id, {
            payments: this.form.payments.map(payment => ({
              expertPurposeType: payment.expertPurposeType,
              unitOfMeasurement: payment.unitOfMeasurement,
              value: payment.value,
              description: payment.description
            }))
          })
          .then(() => {
            this.closeModal()
            this.$emitter.emit('refreshSectionPayments')
            this.$emitter.emit('refresh-resolutions', {reload: false})
            this.$snotify.success(this.$lang.app.SUCCESS_ACTION)
          }).catch(error => {
            if(error.response.data.status === 422) {
              this.setValidationErrors(actions, error.response.data.errors)
            } else {
              this.$snotify.error(error)
            }
          })
          .finally(() => {
            this.submitting = false
          });
    }
  },
  beforeMount() {
    this.$emitter.on('openAddPaymentModal', resolution => {
      this.resolution = resolution
      this.openModal()
      this.form = {
        payments: [],
      }
      this.addPayment()
    })
  },
  beforeUnmount() {
    this.$emitter.off('openAddPaymentModal')
  }
}
</script>
<style>
.side-modal-body {
  height: calc(100vh - 164px);
}
</style>
